// src/components/Ouvidoria/PublicProtocolSearch.js

import React, { useState } from 'react';
import { FaSearch, FaSpinner, FaCommentDots, FaExclamationCircle } from 'react-icons/fa';

// IMPORTANTE: Cole aqui a URL da sua Cloud Function "consultarProtocoloPublico"
const SEARCH_FUNCTION_URL = 'https://consultarprotocolopublico-aap3px27dq-rj.a.run.app/'; // Substitua pela sua URL

const PublicProtocolSearch = ({ empresaId }) => {
    const [protocolId, setProtocolId] = useState('');
    const [submission, setSubmission] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [searched, setSearched] = useState(false);

    const handleSearch = async (e) => {
        e.preventDefault();
        if (protocolId.trim().length < 5) {
            setError('Por favor, insira um número de protocolo válido.');
            return;
        }

        setIsLoading(true);
        setError('');
        setSubmission(null);
        setSearched(true);

        try {
            const response = await fetch(SEARCH_FUNCTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ empresaId, protocolId }),
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Protocolo não encontrado ou erro no servidor.');
            }
            
            const data = await response.json();
            setSubmission(data);

        } catch (err) {
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    // --- FUNÇÃO AJUSTADA PARA LER A DATA EM FORMATO DE TEXTO (ISO STRING) ---
    const formatTimestamp = (isoString) => {
        if (!isoString) return '...';
        // A função new Date() consegue interpretar a string ISO diretamente
        return new Date(isoString).toLocaleString('pt-BR');
    };

    return (
        <div className="ouvidoria-protocol-view">
            <div className="protocol-search-box">
                <h2><FaSearch /> Consultar Protocolo</h2>
                <p>Insira o código recebido ao enviar sua mensagem para ver o status e as respostas.</p>
                <form onSubmit={handleSearch}>
                    <input
                        type="text"
                        placeholder="Digite seu protocolo aqui..."
                        value={protocolId}
                        onChange={(e) => setProtocolId(e.target.value)}
                        className="form-control"
                    />
                    <button type="submit" className="btn-primary" disabled={isLoading}>
                        {isLoading ? <FaSpinner className="spinner" /> : 'Buscar'}
                    </button>
                </form>
            </div>

            {isLoading && <div className="loading-ouvidoria"><FaSpinner className="spinner" /> Buscando informações...</div>}
            
            {error && <p className="error-message">{error}</p>}
            
            {!isLoading && !error && submission && (
                <div className="submission-details-card">
                    <h3>Detalhes da Manifestação</h3>
                    <div className="details-grid">
                        <p><strong>Protocolo:</strong> {protocolId}</p>
                        <p><strong>Data de Envio:</strong> {formatTimestamp(submission.createdAt)}</p>
                        <p><strong>Categoria:</strong> {submission.category}</p>
                        <p><strong>Status:</strong> <span className={`status-badge status-${submission.status}`}>{submission.status.replace('_', ' ')}</span></p>
                    </div>

                    <div className="message-section">
                        <strong>Sua Mensagem Original:</strong>
                        <p className="original-message">{submission.message}</p>
                    </div>

                    <div className="replies-section">
                        <h4><FaCommentDots /> Respostas da Ouvidoria</h4>
                        {submission.replies && submission.replies.length > 0 ? (
                            submission.replies.map((reply, index) => (
                                <div key={index} className="reply-item">
                                    <p>{reply.message}</p>
                                    <small>Respondido por Ouvidoria em {formatTimestamp(reply.repliedAt)}</small>
                                </div>
                            ))
                        ) : (
                            <div className="no-replies">
                                <FaExclamationCircle />
                                <p>Ainda não há respostas para a sua manifestação. Por favor, verifique novamente mais tarde.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {!isLoading && searched && !submission && !error && (
                 <div className="empty-state-ouvidoria">
                    <h3>Nenhum resultado</h3>
                    <p>Verifique o número do protocolo e tente novamente.</p>
                </div>
            )}
        </div>
    );
};

export default PublicProtocolSearch;